import { useState, useEffect } from 'react';

function getWidth() {
  return typeof window !== 'undefined' ? window.innerWidth : 1280;
}

export function useWindowSize() {
  const [width, setWidth] = useState(getWidth);

  useEffect(() => {
    const handler = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return {
    width,
    isMobile:  width < 768,
    isTablet:  width >= 768 && width < 1024,
    isDesktop: width >= 1024,
  };
}
